/**
 * Mark consecutive rows for the same house as continuations.
 *
 * The offers table carries one row per offer DATE, so a house with three
 * offer periods appears three times - The Castle and Little Cheriton House
 * both do, and it reads as a glitch while scanning rather than as three
 * separate dates. Rows are not merged: the prices differ between dates for
 * a good number of houses (Royale Retreat is £2,895 on one date and £2,500
 * on another), so collapsing them would lose real information.
 *
 * Runs after every sort as well as on load, because sorting reorders the
 * rows and "adjacent" is only true of the order currently on screen.
 */
function markRepeatedRows(table) {
    let previous = null;

    table.querySelectorAll('tbody tr').forEach(row => {
        const house = row.getAttribute('data-house');

        row.classList.toggle('is-repeat', house !== null && house === previous);

        previous = house;
    });
}

export function sortableTable() {
    document.querySelectorAll('table[data-sort-group]').forEach(markRepeatedRows);

    document.querySelectorAll('th[data-sort]').forEach(heading => {
        heading.addEventListener('click', () => {
            const table = heading.closest('table');
            const name = heading.getAttribute('data-sort');
            const rows = Array.from(table.querySelectorAll('tbody tr'));

            // Determine the current sort direction
            const currentSortDirection = heading.getAttribute('data-sort-direction') || 'asc';
            const isAscending = currentSortDirection === 'asc';

            const sortedRows = rows.sort((a, b) => {
                const aCell = a.querySelector(`td[data-name="${name}"]`);
                const bCell = b.querySelector(`td[data-name="${name}"]`);

                if (!aCell || !bCell) {
                    return 0;
                }

                const aValue = aCell.getAttribute('data-value') || '';
                const bValue = bCell.getAttribute('data-value') || '';

                const comparison = aValue.localeCompare(bValue, undefined, { numeric: true });

                return isAscending ? comparison : -comparison;
            });

            const tbody = table.querySelector('tbody');
            tbody.innerHTML = '';
            sortedRows.forEach(row => tbody.appendChild(row));

            markRepeatedRows(table);

            // Toggle the sort direction
            const newSortDirection = isAscending ? 'desc' : 'asc';
            heading.setAttribute('data-sort-direction', newSortDirection);

            // Remove the data-sort-direction attribute from sibling th elements
            heading.parentElement.querySelectorAll('th[data-sort]').forEach(sibling => {
                if (sibling !== heading) {
                    sibling.removeAttribute('data-sort-direction');
                }
            });
        });
    });
}
